import {Component, OnInit} from '@angular/core';
import {NotificationsService} from '../api/notifications.service';
import {ConfirmationService} from 'primeng/api';
import {HttpErrorResponse} from '@angular/common/http';
import {EMPTY} from 'rxjs';
import {ManageConstraintService} from '../api/manage-constraint.service';
import {ItemConstraint} from '../model/item-constraint';
import {RpcService} from '../api/rpc.service';
import {ItemConstraintRequest} from '../model/Item-constraint-request';
import {ItemConstraintType} from '../model/ItemConstraintType';
import {GeographicArea} from '../model/geographic-area';
import {Tiers} from '../model/tiers';
import {toCode} from '../model/geographic-area-type';

@Component({
  selector: 'app-manage-constraint',
  templateUrl: './manage-constraint.component.html',
  styleUrls: ['./manage-constraint.component.scss']
})
export class ManageConstraintComponent implements OnInit{

  private _isLoading: boolean;
  private _isDeleting: boolean;
  private _is_updating: boolean;
  public userId;
  public connectedUserId;
  public permissions : string[];

  // table initialization
  public pageNumber: number = 1;
  public pageSize: number = 20;
  public availableItemConstraintTypes : DropDownOptions [] = [];

  // filter variants
  public idItemConstraint: number;
  public code : number;
  public itemConstraintType: string;
  public totalItemConstraints: number;

  // filter & item list
  public filters = {'user':{value:''}};
  public _itemConstraintsList : ItemConstraint [] = [];

  //add constraint
  isModalAddConstraintOpen = false;
  //export constraint
  isModalExportConstraintOpen = false;

  // user countries
  authorized_countries:  string[];
  mapItemConstraintIdToTiersConcat: Map<number, Tiers> = new Map<number, Tiers>();
  geographicAreaList: GeographicArea [];

  constructor(private notificationService: NotificationsService,
              private confirmationService: ConfirmationService,
              private notificationsService: NotificationsService,
              private manageConstraintService : ManageConstraintService,
              private rpcService : RpcService) {}

  ngOnInit(): void {
    this._isLoading = true;
    this.mapConstraintTypeList();
  }

  mapConstraintTypeList(): void {
    this.manageConstraintService.getConstraintType().subscribe((itemConstraintTypes: ItemConstraintType[]) => {
      this.availableItemConstraintTypes = [
        { label: 'ALL TYPE', value: '' },
        ...itemConstraintTypes.map(type => ({ label: type.name, value: type.name }))
      ];
      this.itemConstraintType = this.availableItemConstraintTypes[0].value;
      this.rpcService.getCurrentUser()
        .subscribe((user) => {
          this.connectedUserId = user.login;
          this.permissions = user.permissions;
          this.filters.user.value = user.login;
          this.userId = user.login;
          this.authorized_countries = user.authorized_countries;
          this.refresh();
        });
    });
  }

  refreshFromTab(event){
    this.pageNumber = event.first/event.rows +1;
    this.pageSize = event.rows;

    this.idItemConstraint = event.filters?.idItemConstraint?.value;
    this.code = event.filters?.code?.value;
    this.userId = event.filters.user.value;
    this.itemConstraintType = event.filters.itemConstraintTypes.value

    this.refresh();
  }

 refreshCounts(){
    this.manageConstraintService.getCounts(this.itemConstraintType, this.idItemConstraint, this.code, this.userId)
      .subscribe(count => {
        this.totalItemConstraints = count;
      }, e => {
      });
  }

  refresh(){
    this.refreshCounts();
    this._isLoading = true;
    this.manageConstraintService
      .getItemConstraints(this.pageSize, this.pageNumber,this.itemConstraintType, this.idItemConstraint, this.code, this.userId)
      .subscribe((items)=> {
        this.buildMap(items);
        this.getGeographicAreasByTiers(Array.from(this.mapItemConstraintIdToTiersConcat.values()), items)
      }, (e)=> {
        this.handleError(e);
        this._itemConstraintsList = [];
        this._isLoading = false;
      });
  }

  buildTiers(itemConstraint : ItemConstraint): Tiers {
    return {
      type: itemConstraint.tier_type,
      code: itemConstraint.tier_code,
      sub_code: itemConstraint.tier_sub_code
    };
  }

  buildMap (items : ItemConstraint []) {
    items.map(item => {
      this.mapItemConstraintIdToTiersConcat.set(item.id_item_constraint, this.buildTiers(item))
    })
  }

  getGeographicAreasByTiers (tiersList : Tiers [], items : ItemConstraint []) : void {
    this.manageConstraintService.getGeographicAreaByTiers(tiersList).subscribe(
      (geos) => {
        this.geographicAreaList = geos
        this._itemConstraintsList = items;
        this._isLoading = false;
      }
    );
  }

  findSalesOrganisationByTiers (tiers : Tiers) : string {
    const geoArea = this.geographicAreaList.find(geoArea =>
      toCode(geoArea.tier_type_code) === tiers.type &&
      geoArea.tier_code === tiers.code &&
      geoArea.tier_sub_code === tiers.sub_code
    )
    if(geoArea != null) {
      return geoArea.sales_organization_code;
    }
  }

  isBeforeNow(date : string){
    return new Date(date + 'Z') < new Date();
  }

  isAfterNow(date : string){
    return new Date(date + 'Z') > new Date();
  }

  humanReadableDate(date: string) : string{
    if(date==null)
      return '/';
    return new Date(date).toLocaleString();
  }

  openExportConstraintModal() {
    this.isModalExportConstraintOpen = true;
  }

  openAddConstraintModal() {
    this.isModalAddConstraintOpen = true;
  }

  delete(lineItem: ItemConstraint){
    let message: string, header: string;
    if(this.isAfterNow(lineItem.start_date)){
      message = ' Are you sure that you want to delete this item constraint?';
      header = `Delete item constraint with id: ${lineItem.id_item_constraint}`;
    }

    if(this.isBeforeNow(lineItem.start_date) || this.isBeforeNow(lineItem.end_date)){
      return false;
    }
     this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._isDeleting = true;
        this.manageConstraintService.deleteItemConstraint(lineItem.id_item_constraint).subscribe(item => {
            this.refresh();
            this._isDeleting = false;
            this.notificationsService.success('Deletion succeeded ', `item constraint : ${lineItem.code} deleted`);

          },
          (e) => {
            this.notificationService.error('Something wrong happened...', `Backend returned code ${e.status} : ${e.error?.error_description}`);
            this._isDeleting = false;
          });
      }
    });
  }

  close (lineItem: ItemConstraint) {
    let message: string, header: string;
    if(this.isBeforeNow(lineItem.start_date) && this.isAfterNow(lineItem.end_date)){
      message = ' Are you sure that you want to close this constraint? (end_date will be set to now)';
      header = 'Close item constraint';
    }
    if(this.isBeforeNow(lineItem.end_date) || this.isAfterNow(lineItem.start_date)){
      return false;
    }
    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this._is_updating = true;
        const itemConstraintRequest : ItemConstraintRequest = {
          item_constraint_type: lineItem.item_constraint_type,
          start_date: lineItem.start_date,
          end_date: new Date().toISOString(),
          comment: 'Closed by ' + this.connectedUserId
        };
        this.manageConstraintService.closeItemConstraint(lineItem.id_item_constraint, itemConstraintRequest).subscribe(item => {
            this.refresh();
            this._is_updating = false;
            this.notificationsService.success('Closing succeeded ', `item constraint : ${lineItem.code} closed`);
          },
          (e) => {
            this.notificationService.error('Something wrong happened...', `Backend returned code ${e.status} : ${e.error?.error_description}`);
            this._is_updating = false;
          });
      }
    });
  }

  handleError(error: HttpErrorResponse)  {
    console.error(`Backend returned code ${error.status}, body was: ${JSON.stringify(error)}`);
    this.notificationsService.error('Something wrong happened...', `Backend returned code ${error.status}`);
    return EMPTY;
  }

  get itemConstraints(): ItemConstraint[] {
    return this._itemConstraintsList;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get isDeleting(): boolean {
    return this._isDeleting;
  }

  get isUpdating(): boolean {
    return this._is_updating;
  }

  canDeleteOrUpdate(itemConstraint: ItemConstraint){
    const tiers : Tiers = this.mapItemConstraintIdToTiersConcat.get(itemConstraint.id_item_constraint);
    const salesOrganization : string = this.findSalesOrganisationByTiers(tiers)

    if(salesOrganization == null) {
      return false;
    }

    return itemConstraint.created_by == this.userId ||
      this.authorized_countries.includes(salesOrganization) || this.authorized_countries.includes('ALL');
  }

  getButtonProperties(lineItem: ItemConstraint) {
    const canModify = this.canDeleteOrUpdate(lineItem);
    if (this.isAfterNow(lineItem.start_date) && canModify) {
      return {
        action: 'delete',
        label: 'Delete',
        styleClass: 'p-button-danger',
        clickHandler: () => this.delete(lineItem)
      };
    } else if (this.isBeforeNow(lineItem.start_date) && this.isAfterNow(lineItem.end_date) && canModify) {
      return {
        action: 'close',
        label: 'Close',
        styleClass: 'p-button-warning',
        clickHandler: () => this.close(lineItem)
      };
    } else {
      return null;
    }
  }

}
 interface DropDownOptions {
  label : string;
  value: string;
 }
